export const encodePath = (path: string) => path.split('/').map(encodeURIComponent).join('/')
export const docsPath = (project: string, path: string, hash = '') => `/p/${encodeURIComponent(project)}/docs/${encodePath(path)}${hash}`
export interface Context { path: string; project: string; sha: string; repository: string | null; docs: ReadonlySet<string> }
/** Resolve only listed docs into the reader; other files stay on the forge at the same commit. */
export function resolveRepoUrl(url: string, kind: 'link' | 'image', ctx: Context): string {
  if (kind === 'image') return ''
  const raw = url.trim()
  if (!raw || raw.startsWith('#') || raw.startsWith('/') || /^[a-z][a-z0-9+.-]*:/i.test(raw)) return raw
  const [before = '', hash] = raw.split('#', 2)
  let relative: string
  try { relative = decodeURIComponent(before.split('?')[0] ?? '') } catch { return '' }
  if (relative.startsWith('/') || relative.includes('\\') || /[\u0000-\u001f\u007f]/.test(relative)) return ''
  const parts = ctx.path.split('/').slice(0, -1)
  for (const part of relative.split('/')) {
    if (part === '.' || part === '') continue
    if (part === '..') { if (!parts.length) return ''; parts.pop() } else parts.push(part)
  }
  const path = parts.join('/')
  const anchor = hash === undefined ? '' : `#${hash}`
  if (ctx.docs.has(path)) return path === ctx.path && anchor ? anchor : docsPath(ctx.project, path, anchor)
  return ctx.repository ? `https://github.com/${ctx.repository}/blob/${ctx.sha}/${encodePath(path)}${anchor}` : ''
}
